import { Component, Input, OnDestroy, OnChanges, AfterViewInit, ViewChild, SimpleChanges } from '@angular/core';
import { NetViewTreeNodeDto } from 'UvExplorerServer.Dtos.TS/NetViews';
import { Changeable } from 'common';
import { LicensingService } from 'identity';
import { UserLink } from '../../../DiscoveryEngine.TS/Discovery';

@Component({
	selector: 'user-link-list',
	templateUrl: './user-link-list.component.html',
	styleUrls: ['./user-link-list.component.scss']
})
export class UserLinkListComponent implements OnChanges, OnDestroy, AfterViewInit, Changeable {

	@Input() public target: NetViewTreeNodeDto;

	public userLinks: UserLink[];
	public displayNewDialog: boolean;

	constructor(private licensingService: LicensingService) {

		if (this.target == undefined) {
			this.target = new NetViewTreeNodeDto(); // If a target isn't given just use a blank one in the short term
		}

		this.userLinks = [];
		this.displayNewDialog = false;
	}

	public get isLicenseValid(): boolean {
		//return this.licensingService.isLicenseValid;
		return true;
	}

	public onNewDialogClose(): void {
		setTimeout(() => {
			this.displayNewDialog = false;
		}, 0);
	}

	public ngOnChanges(changes: SimpleChanges): void {
		this.rebuildUserLinks();
	}

	public ngAfterViewInit(): void {

	}

	public ngOnDestroy(): void {

	}

	public addNew() {
		this.displayNewDialog = true;
	}

	//public deleteLinks() {
	//	this.userLinks.forEach((value) => {
	//		if (value.markedForDelete) {
	//			this.userLinks = this.userLinks.filter((obj) => {
	//				return obj.GUID !== value.GUID;
	//			});

	//			// Delete from NetViewTree
	//			this.target.DeleteUserLink(value.GUID);
	//			this.target.HasChanges = true;
	//		}
	//	});
	//}

	public deleteLink(userLink: UserLink): void {
		this.userLinks = this.userLinks.filter((ul: UserLink) => {
			return (ul.GUID !== userLink.GUID);
		});

		this.target.DeleteUserLink(userLink.GUID);

		this.target.HasChanges = true;
	}

	public rebuildUserLinks() {
		if (this.target) {
			this.userLinks = [...this.target.UserLinks.Values];
		}
		else {
			this.userLinks = [];
		}
	}

	//
	// Changeable
	//

	public get tempChanges(): boolean {
		return false;
	}

	// PRE: tempChanges === true
	public get tempChangesValid(): boolean {
		return true;
	}

	// PRE: tempChanges === true && tempChangesValid === false
	public get invalidTempChanges(): string[] {
		return [];
	}

	// PRE: tempChanges === true && tempChangesValid === true
	public applyTempChanges(): void {

	}

	// PRE: tempChanges === true
	public discardTempChanges(): void {

	}
}